import React from "react";
import {
  Layout, Menu, FloatButton, Avatar, Tooltip, Button, Affix, Space, Dropdown, message, Drawer, Alert
} from "antd";
import MenuIcon from '@mui/icons-material/Menu';
import { Route, Switch, Link, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import RouteFields from "Routes/RouteFields";
import CommonButton from 'Components/CommonButton';
import utils from "utils";
import api from "../utils/api";
import {
  LoggedUserRoutes, DoctorRoutes, GuestUserRoutes, CareAdminRoutes,
  SubscriptionPlanRoutes, SuperAdminRoutes, CorperateAdminRoutes,
  CareAdminDomainRoutes, SettingsRoutesCase1, SettingsRoutesCase2, SettingsDoctorRoutes, LogoutRoutes, SupervisingDoctorsRoutes,
  ROLE_ROUTES
} from "../Routes/Route";
import "antd/dist/reset.css";
import PageNotFound from "Pages/NotFound/NotFound";
import Loader from "Components/Loader";
import CareChatWidget from "Pages/Chat/CareChatWidget";
import icons from "Common/Icons";
import Swal from "sweetalert2";
import "./Layout.scss";
import { breadCrumbroutesDelete } from "store/slice/breadcrumb-slice";
import { recentRoutes, upComingPath } from "store/slice/login-slice";
import { setNetworkDrop, setIsChatOpened } from "store/slice/login-slice";
import { setLanguage } from "store/slice/login-slice";
import { removeFilteredValue } from "store/slice/ticketlistFilter-slice";
import { removeFilteredCouponValue } from "store/slice/couponslistFilter-slice";
import { setCollapse, setLabelColorTheme, setContactColorTheme } from "store/slice/dashboard-slice";
import { ONLINE_MSG, OFFLINE_MSG, GUEST_ROUTES, PUBLIC_ROUTES, HEADER_GUEST_ROUTES } from "Common/constant";
import { CopyrightOutlined, UserOutlined, HomeOutlined, FileTextOutlined , CalendarOutlined, UploadOutlined } from '@ant-design/icons';
import PromptModal from "Components/PromptModal";
import { withTranslation, Trans } from "react-i18next";
import { PRIMARY_LANG, ORG_ID, LANG_STYLD_EXT, TS_STYLD_COMPS } from "Common/constant";
import Heading from "Components/Heading";
import PatientChatWidgetNewVersion from "Pages/Chat/PatientChatWidgetNewVersion";
import { resetFunnelingData } from "store/slice/assessment-slice";
import { CONSTANTS } from "utils/constant";
import { PATHWAY_ROUTES } from "Common/constant";
import { t } from "i18next";
import Appointment from "Pages/Appointment/Appointment";
import AlertIcon from '../../src/assets/icons/Alert_Icon.svg'
import { TermsCloseIcon, BottomBarHome, BottomBarAppointment, BottomBarVideos, BottomBarPricing } from "Common/ReactIcons";
import Time_Zone_Dash from "../../src/assets/icons/Time_Zone_Dash.svg";
import Lang_Dash from "../../src/assets/icons/Lang_Dash.svg"
import X_close from "../../src/assets/icons/X_close.svg"
import { setTimeZoneOffset } from "store/slice/login-slice";
import i18n from "i18n";
import { is_web_view } from "Common/constant";
import { SkeletonAvatar } from "Components/PhotoSkeleton";

const { SubMenu } = Menu;
const { Content, Sider, Footer, Header } = Layout;
class MainLayout extends React.Component {
  _routesPath = [];
  constructor(props) {
    super(props);

    let pathname = window.location.pathname.split("/");
    let { user_details, account_details } = this.props || {};
    this.state = {
      role: user_details?.role || "guest",
      name: user_details?.first_name ? user_details?.first_name : user_details?.name,
      baseUrl: user_details?.baseUrl || "guest-user",
      user_details: user_details,
      account_details: account_details,
      selectedPath: pathname[pathname.length - 1],
      routes: [],
      windowResize: window?.innerWidth,
      collapse: false,
      crumbUpdate: true,
      previousPath: this.props.previousPath,
      showNetworkBar: false,
      isOfflineNav: false,
      openKeys: [],
      rootSubmenuKeys: [],
      isLiveChatOpen: false,
      isAiBotChatOpen: false,
      chatDetails: null,
      ai_support: false,
      color_theme: true,
      organisation_mini_logo: "",
      organisation_company_logo: "",
      organisation_id: "",
      label_color_theme: "",
      careadmin_contact_theme: "",
      utmModalOpenedOnce: true,
      isUTMModalOpen: false,
      isBottomBarVisible: false,
       activeTab: "home",
       alertVisible: true,
       alertVisibleLang: true,
        activeAlertIndex: 0,
        tzListOptions: [],
    tzOffsetsInMins: [],
    currentTZ: null,
    selectedCountry: null,
    isLoading: false,
    isButtonLoading: false,
    savedTimezoneOffset: null, 
    userLanguage: "",
    };
    this.storeRedirect = this.storeRedirect.bind(this)
    this.handleLogout = this.handleLogout.bind(this);
    this.openLogout = this.openLogout.bind(this);
    this.WindowUrlRef = React.createRef();
  }
  componentWillUnmount() {
     window.removeEventListener("resize", this.handleResize);
    utils.Modal(false)
  }
  getRoutes() {
    let { role, baseUrl, routes, user_details } = this.state;
    if (this.props.isRoleSelected) {
      let subscription =
        localStorage.getItem("subscription") === null || undefined
          ? {}
          : JSON.parse(localStorage.getItem("subscription"));
      let {
        is_membership_active,
        membership_type,
        is_membership_expired,
        membership_expiry_date,
        is_evaluated,
      } = subscription || {};
      if (role == "patient") {
        let pathname = location.pathname.split("/");
        let tempRoutesPrev = user_details.is_profile_active && (this.props.up_coming_path == "dashboard" || pathname[pathname.length - 1] == "dashboard" || pathname[pathname.length - 1] == "consultation-history" || pathname[pathname.length - 1] == "assessment-history" || pathname[pathname.length - 1] == "health-profile" || pathname[pathname.length - 1] == "select-assessment" || pathname[pathname.length - 1] == "schedule-appointment" || pathname[pathname.length - 1] == "subscription-plan" || pathname[pathname.length - 1] == "my-order" || pathname[pathname.length - 1] == "my-account" || pathname[pathname.length - 1] == "emotion" || pathname[pathname.length - 1] == "stress" || pathname[pathname.length - 1] == "geriatric") && pathname[pathname.length - 1] != 'profile-lists' ? [...LoggedUserRoutes,] : [];
        let tempRoutes=tempRoutesPrev;
        if(user_details.org_type=="individual" || user_details.org_type=="corporate"){
          tempRoutes.push(...SubscriptionPlanRoutes)
        }
        // if ((is_membership_expired || (membership_type) || !is_membership_active || !membership_expiry_date || is_evaluated) && (user_details?.org_type == "individual" || user_details?.org_type == "corporate") && user_details.is_profile_active && pathname[pathname.length - 1] != 'profile-lists' && pathname[pathname.length - 1] != 'login') 
        //   tempRoutes = [...tempRoutes, ...SubscriptionPlanRoutes];
        // tempRoutes  = [...tempRoutes, ...ProfileListRoutes];
        //  tempRoutes = tempRoutes.splice(tempRoutes.length-1,0,...SubscriptionPlanRoutes)
        if (tempRoutes.length > 0) {
          this.props.upComingPath("dashboard");
        }
        let settingsFlag = true;
        let settingsSwitchFlag = true;
        if (tempRoutes.length > 0 && (this.state.account_details?.user_id != this.state.user_details?.user_id)) {
          tempRoutes.push(...SettingsRoutesCase2)
          settingsSwitchFlag = false;
        }
        if ((this.state.selectedPath == 'my-account' || location.pathname == '/logged-in-user/profile-lists') && !this.state.user_details?.is_account_owner) {
          settingsFlag = false;
          tempRoutes = [...SettingsRoutesCase1]
        }
        if (((this.state.account_details?.user_id == this.state.user_details?.user_id) || this.state.selectedPath == 'my-account' || this.state.selectedPath == 'profile-lists') && settingsFlag && settingsSwitchFlag)
          tempRoutes.push(...SettingsRoutesCase1)
        if ((this.props.user_details.org_type == "corporate" && this.props.user_details.is_profile_completed) || this.props.user_details.org_type == "individual") {
          tempRoutes = tempRoutes.filter(item => !PATHWAY_ROUTES.includes(item.path))
        }
        routes = tempRoutes;
        baseUrl = "/logged-in-user";
      } else if (role == "doctor") {
        routes = [...DoctorRoutes];
        if (this.state.user_details.is_supervising_clinician)
          routes = [...routes, ...SupervisingDoctorsRoutes];
        routes = [...routes, ...SettingsDoctorRoutes];
        baseUrl = "/doctor";
      } else if (role == "care-admin") {
        let careRoutes = {
          0: ["care-admin-domain"],
          1: [
            "care-admin-domain",
            "dashboard",
            "select-tickets",
            "tickets-list",
            "search-patient",
            "add-medicine",
            "consultation-list",
            "doctor-availabilty",
            "org-records",
            "patient-lists",
            "plan-history",
            "patient-plan",
            "my-tickets",
            "manage-coupon",
            "patient-records",
            "patient-consultation",
            // "analytics"
          ],
          2: ["care-admin-domain", "chat"],
        };
        if (this.state.user_details?.is_supervising_care_admin)
          careRoutes[1].push("analytics")
        let key = this.props.selected_care_admin_domain || "all";
        let tempRoutes = [...CareAdminRoutes];
        let finalRoutes = tempRoutes.filter((m) => {
          let tempString = m.path.replace("/", "");
          if (key == "all") return false;
          else if (careRoutes[key]?.includes(tempString)) return true;
          else return false;
        });
        if (key == "all") finalRoutes = [...CareAdminDomainRoutes];
        routes = [...finalRoutes];
        if (this.props.location.pathname == "/care-admin/care-admin-domain") routes = [...CareAdminDomainRoutes];
        baseUrl = "/care-admin";
      } else if (role == "super_admin") {
        routes = SuperAdminRoutes;
        baseUrl = "/super-admin";
      } else if (role == "client-admin") {
        routes = [...CorperateAdminRoutes];
        baseUrl = "/corporate-admin";
      } else {
        routes = GuestUserRoutes;
        baseUrl = "/guest-user";
      }
      if (this.props.isMultipleRolePresent)
        routes = [...routes, ...ROLE_ROUTES]
      return { routes, baseUrl };
    } else {
      if (this.state.role == "role") {
        baseUrl = "/role-types";
        routes = ROLE_ROUTES;
        return { routes, baseUrl };
      } else {
        routes = GuestUserRoutes;
        baseUrl = "/guest-user";
        return { routes, baseUrl };
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      (prevState.showNetworkBar && prevState.isOfflineNav) ||
      (nextProps.networkError && !navigator.onLine)
    ) {
      throw new Error("Network Error");
    }

    if (nextProps.user_details !== prevState.user_details) {
      let { user_details, account_details } = nextProps || {};
      return {
        user_details: user_details,
        account_details: account_details,
        role: user_details?.role || "guest",
        name: user_details?.first_name,
        baseUrl: user_details?.baseUrl,
      };
    } else return null;
  }

  validateLangRetainment() {
    if (
      this.props.user_details.language &&
      this.props.i18n.language != this.props.user_details.language
    ) {
      this.props.i18n.changeLanguage(this.props.user_details.language);
      if (this.props.user_details.language != PRIMARY_LANG) {
        this.props.setLanguage({
          language: this.props.user_details.language,
          includePrimeLang: true,
        });
      }
    }
  }

  setSelectedMenuItem() {
    let pathname = location.pathname.split("/");
    // let flag = this.state.routes.findIndex(obj => {
    //   if (obj.hasOwnProperty("children")) {
    //     return obj.children.findIndex(m => m.path.indexOf(pathname) != -1)
    //   }
    //   return false;

    // });
    let flag = false;
    let routeValue = "";
    let { routes } = this.getRoutes();
    (routes || []).forEach((route, index) => {
      if (!route.children) {
        if (route?.value == pathname[pathname.length - 1]) {
          flag = true;
          routeValue = route?.selectedMenu || pathname[pathname.length - 1];
        }
      } else {
        route.children.forEach((childRoute) => {
          if (childRoute?.value == pathname[pathname.length - 1]) {
            flag = true;
            routeValue = childRoute?.value || "";
          }
        });
      }
    });
    if (!flag) {
      this.setState(
        (prevState) => ({
          selectedPath: prevState.selectedPath,
        }),
        () => {
          this.props.recentRoute(this.state.selectedPath);
        }
      );
    } else {
      this.setState(
        {
          selectedPath: routeValue,
        },
        () => {
          this.props.recentRoute(this.state.selectedPath);
        }
      );
    }
    // if(flag){
    //   this.setState({
    //     selectedPath: pathname[pathname.length - 1],
    //   })
    // }
  }

  handleCareViewMessage(selectedPatient) {
    this.setState({
      selectedPatient: selectedPatient,
    });
  }

  prepareRoutes() {
    let menus = [];
    let childrenSupportedKeys = [];
    let { baseUrl, routes } = this.getRoutes();

    (routes || []).forEach((route, index) => {
      let disable = this.props.location.pathname.includes("video-consultation") ? true : false;
      if (route.showmenu) {
        if (!route.children) {
          menus.push({
            ...route,
            key: route?.value || "",
            label: disable ? this.props.t(route?.label, { lng: PRIMARY_LANG }) : <Link to={`${baseUrl}${route.path}`}>{this.props.t(route?.label, { lng: PRIMARY_LANG })}</Link>,
            theme: "dark",
            showmenu: "",
            style: { paddding: 0 },
            // theme:"dark",
            showmenu: "",
            disabled: disable,
          });
          childrenSupportedKeys.push(route.value)
        } else {
          let newChildren = route.children.map((subItem, j) => {
            return {
              ...subItem,
              key: subItem.value,
              style: { paddding: 0 },
              theme: "dark",
              label: disable ? <>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</> : subItem.value == "logout" ? <a onClick={e => e.preventDefault()}>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</a> : <Link to={`${baseUrl}${subItem.path}`}>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</Link>,
              disabled: disable,
            }
          })
          menus.push(
            {
              ...route,
              key: route.value,
              children: newChildren,
              showmenu: "",
              style: { paddding: 0 },
              theme: "dark",
              disabled: disable,
            }
          )
          childrenSupportedKeys.push(route.value)
        }
      }
    })
    this.rootSubmenuKeys = childrenSupportedKeys;
    // console.log(childrenSupportedKeys)
    return menus;
  }
  preparesmallRoutes() {
  let menus = [];
  let childrenSupportedKeys = [];
  let { baseUrl, routes } = this.getRoutes();
  (routes || []).forEach((route, index) => {
    let disable = this.props.location.pathname.includes("video-consultation") ? true : false;
    if (route.showmenu) {
      if (!route.children) {
        // Exclude the `icon` property
        const { icon, ...restRoute } = route;
        menus.push({
          ...restRoute,
          key: route?.value || "",
          label: disable
            ? this.props.t(route?.label, { lng: PRIMARY_LANG })
            : <Link to={`${baseUrl}${route.path}`}>{this.props.t(route?.label, { lng: PRIMARY_LANG })}</Link>,
          theme: "dark",
          style: { padding: 0 },
          disabled: disable,
        });
        childrenSupportedKeys.push(route.value);
      } else {
        let newChildren = route.children.map((subItem, j) => {
          // Exclude the `icon` property for sub-items
          const { icon, ...restSubItem } = subItem;
          return {
            ...restSubItem,
            key: subItem.value,
            style: { padding: 0 },
            theme: "dark",
            label: disable
              ? <>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</>
              : subItem.value == "logout"
                ? <a onClick={e => e.preventDefault()}>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</a>
                : <Link to={`${baseUrl}${subItem.path}`}>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</Link>,
            disabled: disable,
          };
        });
        // Exclude the `icon` property for the parent item
        const { icon, ...restRoute } = route;
        menus.push({
          ...restRoute,
          key: route.value,
          children: newChildren,
          style: { padding: 0 }, 
          theme: "dark",
          disabled: disable,
        });
        childrenSupportedKeys.push(route.value);
      }
    }
  });
    menus.push({
    key: "logout",
    label: <a >{this.props.t("Logout", { lng: PRIMARY_LANG })}</a>,
    theme: "dark",
    style: { padding: 0 },
    onClick: () => {this.toggleSidebar.bind(this);},
    icon: null, // Explicitly set to null if not needed
  });
  this.rootSubmenuKeys = childrenSupportedKeys;
  return menus;
}


  checkAndStoreDeepLink() {
    let pathname = window.location.pathname.split("/");
    // if (
    //   this.state.user_details?.role == "Guest" &&
    //   !PUBLIC_ROUTES.includes(pathname[pathname.length - 1])
    // ) {
    if (
      this.state.user_details?.role == "Guest" &&
      !PUBLIC_ROUTES.includes(window.location.pathname)
    ) {
      //sessionStorage.setItem("deepLinkUrl", pathname[pathname.length - 1]);
      // sessionStorage.setItem("deepLinkUrl", window.location.pathname);
    }
  }

  prepareRoutesView(routes) {
    this.checkAndStoreDeepLink();
    let { baseUrl } = this.getRoutes();
    (routes || []).forEach((route, index) => {
      if (
        route.path &&
        route.component &&
        (utils.IsClassComponent(route.component) ||
          utils.IsFunctionalComponent(route.component))
      ) {
        this._routesPath.push(
          <Route
            path={`${baseUrl}${route.path}`}
            key={`${baseUrl}${route.path}-${index}`}
          >
            <route.component />
          </Route>
        );
      } else if (
        route.path &&
        route.render &&
        typeof route.render == "function"
      ) {
        this._routesPath.push(
          <Route
            path={`${baseUrl}${route.path}`}
            render={(props) => route.render(props)}
            key={`${baseUrl}${route.path}-${index}`}
          ></Route>
        );
      } else if (
        route.path &&
        route.component &&
        React.isValidElement(route.component)
      ) {
        this._routesPath.push(
          <Route
            path={`${baseUrl}${route.path}`}
            key={`${baseUrl}${route.path}-${index}`}
          >
            {route.component}
          </Route>
        );
      } else if (route.path && route.component === null) {
        this._routesPath.push(
          <Route
            path={`${baseUrl}${route.path}`}
            key={`${baseUrl}${route.path}-${index}`}
          >
            <div>{route.label}</div>
          </Route>
        );
      }

      if (route.hasOwnProperty("children")) {
        this.prepareRoutesView(route.children);
      }
    });
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.state.selectedPath !== "video-consultation" && this.props.previousPath !== nextProps.previousPath) {
  //     return true
  //   }
  //   if (this.props.previousPath != []) {
  //     return true
  //   }

  // }

  getSidebarStatus() {
    let show = "show";
    if (
      Object.keys(this.state.user_details || {}).length &&
      this.state.role &&
      this.state.role == "Guest" &&
      this.state.baseUrl == "/guest-user"
    ) {
      show = "hide";
    } else if (
      Object.keys(this.state.user_details || {}).length &&
      this.state.role &&
      this.state.role == "care-admin" &&
      this.state.selectedPath == "care-admin-domain"
    ) {
      show = "hide";
    } else if (this.state.user_details == undefined) {
      show = "hide";
    } else if (this.state.selectedPath == "care-admin-domain") {
      show = "hide";
    }

    return show;
  }
  handleResize = () => {
    // this.setState({ windowResize: window.innerWidth});
    if (window.innerWidth <= 600) {
      this.setState({
        collapse: true,
          isBottomBarVisible: true,
      });
    } else {
      this.setState({
        collapse: false,
        isSidebarOpen: false,
         isBottomBarVisible: false,
      });
    }
  };

  prepareBottomBarRoutes() {
  const { t } = this.props;
  const { baseUrl } = this.getRoutes();
  const bottomBarRoutes = [
    {
      key: "dashboard",
      label: t("Dashboard", { lng: PRIMARY_LANG }),
      icon: <HomeOutlined />, // Replace with your icon
      path: `${baseUrl}/dashboard`,
    },
    {
      key: "assessment",
      label: t("Assessment", { lng: PRIMARY_LANG }),
      icon: <FileTextOutlined  />, // Replace with your icon
      path: `${baseUrl}/select-assessment`,
    },
    {
      key: "appointment",
      label: t("Appointment", { lng: PRIMARY_LANG }),
      icon: <CalendarOutlined />, // Replace with your icon
      path: `${baseUrl}/schedule-appointment`,
    },
    {
      key: "file-upload",
      label: t("File Upload", { lng: PRIMARY_LANG }),
      icon: <UploadOutlined />, // Replace with your icon
      path: `${baseUrl}/file-upload`, // Adjust path as needed
    },
    {
      key: "profile",
      label: t("Profile", { lng: PRIMARY_LANG }),
      icon: <UserOutlined />, // Replace with your icon
      path: `${baseUrl}/health-profile`, // Adjust path as needed
    },
  ];
  return bottomBarRoutes;
}


  handleOnline() {
    this.setState({ isOnline: true });
    setTimeout(() => {
      this.setState({ showNetworkBar: false });
    }, 3000);
  }

  componentDidUpdate(prevProps) {
  //     const prevPath = prevProps.location.pathname;
  // const currentPath = this.props.location.pathname;

  // // Reload ONLY when navigating to dashboard
  // if (
  //   prevPath !== currentPath &&
  //   currentPath === "/logged-in-user/dashboard"
  // ) {
  //   window.location.reload();
  // }
    if (this.state.color_theme || this.state.organisation_id != (this.props?.user_details?.org_name || (this.state.user_details?.role == "Guest" && window.location.host) || "default"))
      this.colorCodeCapture();
    window.addEventListener("resize", this.handleResize);
    this.validateLangRetainment();
    if (this.props.location !== prevProps.location) {
      this.setSelectedMenuItem();
      this.setActiveTabFromRoute();
    }
    if (this.props.location.pathname !== prevProps.location.pathname) {
    const path = this.props.location.pathname.split("/").pop(); // last part
    this.setState({ selectedPath: path });
  }
    return;
  }


  setActiveTabFromRoute = () => {
  const { pathname } = this.props.location;
  const { baseUrl } = this.getRoutes();

  // Map routes to tabs
  const routeToTabMap = {
    [`${baseUrl}/dashboard`]: "home",
    [`${baseUrl}/assessment`]: "assessment",
    [`${baseUrl}/consultation-history`]: "appointment",
    [`${baseUrl}/subscription-plan`]: "pricing",
    [`${baseUrl}/preferred-clinician`]: "appointment",
    [`${baseUrl}/file-upload`]: "upload",
    [`${baseUrl}/document-upload`]: "upload",
    // also matches my-account-child (the profile page for non-owner accounts)
    [`${baseUrl}/my-account`]: "profile",
    [`${baseUrl}/health-profile`]: "profile",
    [`${baseUrl}/my-order`]: "profile",
  };

  // Find the active tab based on the current pathname
  // const activeTab = Object.keys(routeToTabMap).find((route) => pathname.startsWith(route));

  // if (activeTab) {
  //   this.setState({ activeTab: routeToTabMap[activeTab] });
  // }
   const matchedRoute = Object.keys(routeToTabMap)
    .find((route) => pathname.startsWith(route));

  if (matchedRoute) {
    const tab = routeToTabMap[matchedRoute];
    this.setState({ activeTab: tab });
    localStorage.setItem("activeTab", tab); // ⭐ STORE IT TOO
  }
};
 handleOffline() {
    this.setState({ isOnline: false, showNetworkBar: true });
  }

  redirectToLogin() {
    this.props.resetFunnelingData();
    this.props.history.replace({
      pathname: "/guest-user/login",           //Redirected to Initial screen instead of login screen                 
    });
  }
  handleSignup() {
    this.props.history.push({
      pathname: "/guest-user/ageCheck",              
    });
  }
  onOpenChange(keyVal) {
    let keys = keyVal?.key ? keyVal.keyPath : keyVal;
    const latestOpenKey = keys.find((key) => this.state.openKeys.indexOf(key) === -1);
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys: keys });
    } else {
      let keysVal = latestOpenKey ? [latestOpenKey] : []
      this.setState({ openKeys: keysVal });
    }
  }

  clearChatDetails() {
    this.setState({ isLiveChatOpen: false, chatDetails: null });
  }

  clearAiBotChatDetails() {
    this.setState({ isAiBotChatOpen: false });
  }

  colorCodeCapture = () => {
    let org_id = this.props?.user_details?.org_name || (this.state.user_details?.role == "Guest" && window.location.host) || "default";
    let colorCode = ORG_ID[org_id] ? ORG_ID[org_id] : ORG_ID["default"];
    colorCode=ORG_ID["Burjeel Holdings"]
    var root = document.documentElement;
    root?.style.setProperty(
      "--background-color", colorCode?.color,
    );
    root?.style.setProperty(
      "--teal-50", colorCode?.teal_50,
    );
    root?.style.setProperty(
      "--teal-100", colorCode?.teal_100,
    );
    root?.style.setProperty(
      "--teal-300", colorCode?.teal_300,
    );
    root?.style.setProperty(
      "--teal-400", colorCode?.teal_400,
    );
    root?.style.setProperty(
      "--teal-500", colorCode?.teal_500,
    );
    root?.style.setProperty(
      "--teal-600", colorCode?.teal_600,
    );
    root?.style.setProperty(
      "--teal-700", colorCode?.teal_700,
    );
    root?.style.setProperty(
      "--teal-800", colorCode?.teal_800,
    );
    root?.style.setProperty(
      "--teal-900", colorCode?.teal_900,
    );
    root?.style.setProperty(
      "--green-100", colorCode?.green_100,
    );
    root?.style.setProperty(
      "--icon-filter", colorCode?.dashbord_tick_icon,
    );
    root?.style.setProperty(
      "--menu-icon-filter", colorCode?.menu_icon,
    );
    this.setState({ color_theme: false, organisation_id: org_id, organisation_mini_logo: colorCode?.mini_logo, organisation_company_logo: colorCode?.full_logo, label_color_theme: colorCode?.label, careadmin_contact_theme: colorCode?.contact_careadmin })
    this.props.setLabelValue(colorCode?.label)
    this.props.setContactValue(colorCode?.contact_careadmin)
  }

  storeRedirect = (store) => {
    // const params = new URLSearchParams(location.search);
    const params = new URLSearchParams(this.WindowUrlRef);
    // const queryParams = Object.fromEntries(params);
    const { user_type, assessment_type, ...queryParams } = Object.fromEntries(params);
    if (store) {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Check if the user is on iOS
      const iOS = /iPhone/.test(userAgent) && !window.MSStream;
      // Check if the user is on Android
      const isAndroid = /android/i.test(userAgent);
      // Construct the URL for redirection based on the platform
      let storeUrl;
      let appUrl;
      if (iOS) {
        storeUrl = `https://v1-app-niyama-ai.onelink.me/EJcM?af_xp=custom&pid=ios&deep_link_value=https%3A%2F%2Fv1.app.niyama.ai%3Futm_source%3D${queryParams?.utm_source}%26utm_medium%3D${queryParams?.utm_medium}%26utm_campaign%3D${queryParams?.utm_campaign}%26first_name%3D${queryParams?.first_name}%26last_name%3D${queryParams?.last_name}%26dob%3D${queryParams?.dob}%26gender%3D${queryParams?.gender}%26email%3D${queryParams?.email}%26mobile%3D${queryParams?.mobile}%26plan_id%3D${queryParams?.plan_id}%26coupon_code%3D${queryParams?.coupon_code}`; // Replace 'YourAppId' with your actual App Store ID
        
        // appUrl = "niyama://?utm_source=${queryParams?.utm_source}&utm_medium=${queryParams?.utm_medium}&utm_campaign=${queryParams?.utm_campaign}";
        this.setState({ isUTMModalOpen: false, utmModalOpenedOnce: false })

        let metaDescription = document.querySelector('meta[name="apple-itunes-app"]');
        if (metaDescription) {
          let content=`app-id=6446277166, app-argument=${process.env.REACT_APP_UTM_URL}utm_source%3D${queryParams?.utm_source}%26utm_medium%3D${queryParams?.utm_medium}%26utm_campaign%3D${queryParams?.utm_campaign}`;
          navigator.clipboard.writeText(`${process.env.REACT_APP_UTM_URL}utm_source%3D${queryParams?.utm_source}%26utm_medium%3D${queryParams?.utm_medium}%26utm_campaign%3D${queryParams?.utm_campaign}%26first_name%3D${queryParams?.first_name}%26last_name%3D${queryParams?.last_name}%26dob%3D${queryParams?.dob}%26gender%3D${queryParams?.gender}%26email%3D${queryParams?.email}%26mobile%3D${queryParams?.mobile}%26plan_id%3D${queryParams?.plan_id}%26coupon_code%3D${queryParams?.coupon_code}`);
          metaDescription.setAttribute('content', content); // Update meta description
        }
        window.location.href = storeUrl;
      } else if (isAndroid) {
        storeUrl = `https://play.google.com/store/apps/details?id=niyama.healthcare${process.env.REACT_APP_ENV == "test" ? ".test" : ""}&referrer=utm_source%3D${queryParams?.utm_source}%26utm_medium%3D${queryParams?.utm_medium}%26utm_campaign%3D${queryParams?.utm_campaign}%26first_name%3D${queryParams?.first_name}%26last_name%3D${queryParams?.last_name}%26dob%3D${queryParams?.dob}%26gender%3D${queryParams?.gender}%26email%3D${queryParams?.email}%26mobile%3D${queryParams?.mobile}%26plan_id%3D${queryParams?.plan_id}%26coupon_code%3D${queryParams?.coupon_code}`

        this.setState({ isUTMModalOpen: false, utmModalOpenedOnce: false })
        window.location.href = storeUrl;
      } else {
        console.log('Unsupported platform');
        return;
      }
    } else {
      this.setState({ isUTMModalOpen: false })
      api
        .save_campaign_data(queryParams)
        .then((res) => {
          let { status } = res.data;
          if (status === 200) {
            localStorage.setItem("qrRedirectData", JSON.stringify(queryParams));
            this.setState({ utmModalOpenedOnce: false })
          } else {
            console.log("Error in ampaign data save");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  componentDidMount() {
    this.colorCodeCapture();
    // this.get_time_zones_list();
    // this.user_info();
    // this.getAllLangs();
     // Initialize
  
   const savedActiveTab = localStorage.getItem("activeTab");
  if (savedActiveTab) {
    this.setState({ activeTab: savedActiveTab });
  }
  this.setActiveTabFromRoute();

  const params = new URLSearchParams(location.search);
    const queryParams = Object.fromEntries(params);
     window.addEventListener("resize", this.handleResize);
  this.handleResize();
    this.WindowUrlRef = location.search;
    if (
      queryParams?.utm_source &&
      queryParams?.utm_medium &&
      queryParams?.utm_campaign
    ) {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const iOS = /iPhone/.test(userAgent) && !window.MSStream;
      const isAndroid = /android/i.test(userAgent);
      if (this.state.utmModalOpenedOnce && (iOS || isAndroid)) {
        this.setState({ isUTMModalOpen: true })
      } else if (this.state.utmModalOpenedOnce && !iOS && !isAndroid) {
        this.storeRedirect(false);
      }
    } else {
      if (this.state.user_details?.role == "patient") {
        api.get_patient_chat_status().then((res) => {
          if (res?.data?.status == 200) {
            let data = res.data?.data ? res.data.data : {}
            if (data?.patient_token) {
              this.setState({
                isLiveChatOpen: true,
                openPatientChat: true,
                chatDetails: data,
              });
            } else {
              if (this.props.retainedAiBotChatDetails?.aiBotChatId) {
                this.setState({ isAiBotChatOpen: true, openPatientChat: true });
              }
            }
          }
        });
      }
      if (!navigator.onLine) {
        throw new Error("Network Error");
      }
      if (navigator.onLine && this.props.networkError) {
        this.props.setNetworkDrop(false);
      }
      this.validateLangRetainment();
      window.addEventListener("online", this.handleOnline.bind(this));
      window.addEventListener("offline", this.handleOffline.bind(this));
    }
    // window.addEventListener('resize', this.handleResize);
  }
  // componentWillUnmount() {
  //   window.removeEventListener('resize', this.handleResize);
  // }
  openLogout = () => {
    const tgtLang = this.props.includePrimeLang
      ? this.props.i18n.language + "_" + PRIMARY_LANG
      : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
    utils.Modal(true, {
      content: (
        <PromptModal
          title={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.LOGOUT_TITLE, { lng: tgtLangST })}</Trans>}
          content={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.LOGOUT, { lng: tgtLangST })}</Trans>}
          subContent={""}
          acptBtnLbl={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.YES, { lng: tgtLangST })}</Trans>}
          rejtBtnLbl={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.NO, { lng: tgtLangST })}</Trans>}
          rejtBtnType="link"
          rejtBtnClsName="link-button-green"
          onAccept={this.handleLogout.bind(this)}
          onReject={() => {
            this.setState((prevState) => ({
              selectedPath: prevState.selectedPath,
            }));
            utils.Modal(false);
          }}
          direction="vertical"
        />
      ),
      width: "500px",
    });
  }
  handleLogout = (e) => {
    const tgtLang = this.props.includePrimeLang
      ? this.props.i18n.language + "_" + PRIMARY_LANG
      : this.props.i18n.language;
    utils.Modal(false);
    // Swal.fire({
    //   text: "Logging Out...",
    //   showConfirmButton: false,
    //   allowOutsideClick: false,
    //   timer: 2000,
    //   timerProgressBar: true,})
    let keysToRemove = [
      "language",
      "subscription",
      "persist:root",
      "rzp_device_id",
      "isLoggedIn",
      "gender",
      "patient_id",
      "patient_user_type",
      "patient_gender",
      "phiReducer",
      "patient_type",
      "is_completed",
      "setGuestUUID",
      "qrRedirectData",
    ];
    for (let key of keysToRemove) {
      localStorage.removeItem(key);
    }
    message.success(t(CONSTANTS.LOGGED_OUT_SUCCESSFULLY, { lng: tgtLang }), 3);
    setTimeout(() => {
      message.destroy();
    }, 3000);
    this.props.logout();
    // if (
    //   process.env.REACT_APP_ENV != "dev" &&
    //   process.env.REACT_APP_ENV != "test"
    // )
    //   window.location.href = "https://www.ziloy.ai/";
  };

  toggleSidebar = () => {
  this.setState((prevState) => ({
    isSidebarOpen: !prevState.isSidebarOpen,
  }));
 
};

 handleNavigation = (tab, path) => {
    this.setState({ activeTab: tab });
     localStorage.setItem("activeTab", tab);
    this.props.history.push(path);
  };

  handleBottomBarItem = (item) => {
    // Videos has no page yet
    if (item.comingSoon) {
      message.info(this.props.t(CONSTANTS.COMING_SOON));
      return;
    }
    this.handleNavigation(item.key, item.path);
  };

  // centre chat button: opens the same care chat as the floating chat button
  openChatFromBottomBar = () => {
    this.setState({ openPatientChat: true });
    this.props.setIsChatOpened(true);
  };


   GotoProfile = () => {
  const { user_details } = this.state;
  if (!user_details?.is_account_owner) {
    this.props.history.push({
      pathname: "/logged-in-user/my-account-child",
    });
  } else {
    this.props.history.push({
      pathname: "/logged-in-user/my-account",
    });
  }
};


// alertchanges


// getCurrentUTCOffset = () => {
//   const offset = this.getCurrentTimezoneOffset();
//   const hours = Math.floor(Math.abs(offset) / 60);
//   const minutes = Math.abs(offset) % 60;
//   const sign = offset >= 0 ? '+' : '-';
//   return `UTC${sign}${hours}:${minutes.toString().padStart(2, '0')}`;
// };

// findMatchingCountry = () => {
//   const currentOffset = this.getCurrentTimezoneOffset(); // User's current offset in minutes
//   const { tzListOptions } = this.state;

//   // Log the current offset for debugging
//   console.log("User's current UTC offset (minutes):", currentOffset);

//   // Find the first country with a matching offset
//   const matchedCountry = tzListOptions.find(
//     (item) => item.offset === currentOffset
//   );

//   // Log the matched country for debugging
//   console.log("Matched country:", matchedCountry);

//   // If no match, return null or handle as needed
//   if (!matchedCountry) {
//     console.warn("No country found for the user's timezone offset.");
//     return null;
//   }

//   return matchedCountry;
// };


// // Helper function to get current browser timezone offset in minutes
// getCurrentTimezoneOffset = () => {
//   return -new Date().getTimezoneOffset(); // Returns offset in minutes
// };

// get_time_zones_list = () => {
//   this.setState({ isLoading: true });

//   api.get_time_zones_list().then((response) => {
//     if (response.data?.status === 200) {
//       const results = response?.data?.data?.results || [];

//       const sortedData = results.slice().sort(
//         (a, b) => a.country_name.localeCompare(b.country_name)
//       );

//       const options = sortedData.map(item => ({
//         label: item.country_name,
//         value: item.country_name,
//         offset: item.time_zone_offset_in_min,
//       }));

//       const selectedItem = sortedData.find(item => item.is_selected);

//       this.setState({
//         tzListOptions: options,
//         currentTZ: selectedItem?.country_name || null,
//         savedTimezoneOffset: selectedItem?.time_zone_offset_in_min || null,
//         isLoading: false,
//       });

//       console.log("Fetched timezone options:", options);
//     }
//   }).catch((error) => {
//     console.error("Error fetching timezone list:", error);
//     this.setState({ isLoading: false });
//   });
// };


// // Update the isTimezoneDifferent function
// isTimezoneDifferent = () => {
//   const currentOffset = this.getCurrentTimezoneOffset();
//   const savedOffset = this.state.savedTimezoneOffset;

//   console.log("Current offset:", currentOffset);
//   console.log("Saved offset:", savedOffset);

//   return currentOffset !== savedOffset;
// };


// updateTimeZone = () => {
//   this.setState({ isButtonLoading: true });

//   const matchedCountry = this.findMatchingCountry();

//   if (!matchedCountry) {
//     message.error("No matching timezone found for your location.");
//     this.setState({ isButtonLoading: false });
//     return;
//   }

//   const data = {
//     time_zone_offset_in_min: matchedCountry.offset,
//     country_name: matchedCountry.value,
//   };

//   console.log("Data being sent to API:", data);

//   api.time_zone_update(data)
//     .then((res) => {
//       this.props.setTimeZoneOffset(matchedCountry.offset);
//       this.setState({
//         savedTimezoneOffset: matchedCountry.offset,
//         alertVisible: false,
//         isButtonLoading: false,
//         currentTZ: matchedCountry.value,
//       });
//       message.success(res.data.message);
//     })
//     .catch((error) => {
//       message.error(error?.message);
//       this.setState({ isButtonLoading: false });
//     });
// };


// languages = [
//   { language: "English", language_type: "en" },
//   { language: "Hindi", language_type: "hi" },
//   { language: "Kannada", language_type: "kn" },
//   { language: "Malay", language_type: "ms" },
//   { language: "Malayalam", language_type: "ml" },
//   { language: "Marathi", language_type: "mr" },
//   { language: "Tamil", language_type: "ta" },
//   { language: "Telugu", language_type: "te" }
// ];


// getCurrentLanguageName() {
//   const storeLanguage = localStorage.getItem('language') || "en";
//   const language = this.languages.find(
//     lang => lang.language_type === storeLanguage
//   );
//   return language?.language || "English";
// }

// user_info() {
//     this.setState({isLoading : true})
//     api.basic_info().then((response) => {
//       if (response.data?.status == 200) {
//         this.setState({
//           countryCode: response.data?.data?.country_code || "+91",
//           userMobileNumber: response.data?.data.mobile_number,
//           userName: response.data?.data?.username,
//           userEmail: response.data?.data?.email,
//           userLastName: response.data?.data?.patient_last_name,
//           userProfile: response.data?.data?.profile_picture,
//           userLanguage: response.data?.data?.language,
//         }, () => {
//           // ✅ Console log only language after setState completes
//           console.log("userLanguage:", this.state.userLanguage);
//         });
//       }
//     }).finally(() => {
//       this.setState({isLoading: false});
//     });
// }

// isLanguageDifferent = () => {
//   const storeLanguage = localStorage.getItem('language') || "en";
//   const profileLang = this.state.userLanguage;

//   console.log("storeLanguage", storeLanguage);
//   console.log("userLanguage", profileLang);

//   return storeLanguage !== profileLang;
// };

//   getAllLangs = () => {
//     this.setState({isLoading : true})
//     api
//       .get_all_languages()
//       .then((response) => {
//         let selected_lang = response.data?.data?.results.find(
//           (item) => item.is_selected
//         )?.lang_value;

//         let tmp_lnglistopt_arr = response.data?.data?.results.map((item) => {
//           return {
//             label: item.lang_name,
//             value: item.lang_value,
//           };
//         });
//         this.setState({
//           allLangs: response.data?.data?.results,
//           langListOptions: tmp_lnglistopt_arr,
//           language: selected_lang ?? null,
//           isLoading : false
//         });
//       })
//       .catch((error) => {});
//   }

// updateLanguage = () => {
//   const storeLanguage = localStorage.getItem('language') || "en";
//   console.log("storeLanguage from localStorage:", storeLanguage);
  
//   const languageData = this.state.allLangs.find(
//     (item) => item.lang_value === storeLanguage
//   );
//   console.log("languageData found:", languageData);
  
//   let data = {
//     language_type: languageData?.lang_value
//   };
//   console.log("Data being sent to API:", data);

//   api
//     .language_update(data)
//     .then((res) => {
//       console.log("API Response:", res.data);
//       message.success(res.data.message, ErrorDuration);
      
//       // Update state to hide alert and sync userLanguage
//       this.setState({ 
//         userLanguage: storeLanguage,
//         alertVisibleLang: false,
//         updatingLang: false, 
//         isButtonLoading: false 
//       });
//       console.log("State updated - userLanguage:", storeLanguage);
      
//       // Update i18n and props if needed
//       i18n.changeLanguage(storeLanguage);
//       this.props.setLanguage({
//         language: storeLanguage,
//         includePrimeLang: storeLanguage != PRIMARY_LANG,
//       });
      
//       // ⚠️ Fixed: Should store storeLanguage string, not data object
//       localStorage.setItem("profilelanguage", storeLanguage);
//       console.log("profilelanguage saved to localStorage:", storeLanguage);
//     })
//     .catch((error) => {
//       console.error("API Error:", error);
//       message.error(error, ErrorDuration);
//       this.setState({ 
//         updatingLang: false, 
//         isButtonLoading: false 
//       });
//     });
// };



// getVisibleAlertsCount = () => {
//   let count = 0;

//   if (
//     this.state.alertVisible &&
//     this.props.location.pathname === "/logged-in-user/dashboard" &&
//     this.isTimezoneDifferent()
//   ) count++;

//   if (
//     this.state.alertVisibleLang &&
//     this.props.location.pathname === "/logged-in-user/dashboard" &&
//     this.isLanguageDifferent()
//   ) count++;

//   return count;
// };


// handleAlertScroll = (e) => {
//   const scrollLeft = e.target.scrollLeft;
//   const width = e.target.offsetWidth;

//   const index = Math.round(scrollLeft / width);

//   if (index !== this.state.activeAlertIndex) {
//     this.setState({ activeAlertIndex: index });
//   }
// };








  render() {
    const tgtLang = this.props.includePrimeLang
      ? this.props.i18n.language + "_" + PRIMARY_LANG
      : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
    const logOutDropDown = [
      {
        key: '3',
        label: (
          <div className="logout-dropdown" onClick={this.openLogout.bind(this)}><img src={icons.logout} />&nbsp;<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.LOGOUT_TITLE, { lng: tgtLangST })}</Trans></div>
        ),
      },
    ];

    let { baseUrl, routes } = this.getRoutes();
    this._routesPath = []
    this._routesPath = this._routesPath.filter((m) =>
      m?.key?.includes(baseUrl)
    );
    this.prepareRoutesView(routes);
    if (this.props.isMultipleRolePresent) {
      this._routesPath.push(
        <Route
          path={`/role-types${ROLE_ROUTES[0].path}`}
          render={(props) => ROLE_ROUTES[0].render(props)}
          key={`/role-types${ROLE_ROUTES[0].path}-key-added`}
        ></Route>
      );
    }
    let options = ["Log Out"];
    if (this.state.account_details?.is_multiple_account) {
      if (
        this.state.account_details?.user_id ==
        this.state.user_details?.user_id ||
        this.state.selectedPath == "profile-lists" ||
        this.state.user_details?.role == "doctor"
      )
        options.unshift("Settings");
      options.unshift("Switch Account");
    }
    if (this.state.user_details?.role == "doctor") options.unshift("Settings");
    // const tgtLang = this.props.user_details.includePrimeLang
    //   ? this.props.i18n.language + "_" + PRIMARY_LANG
    //   : this.props.i18n.language;


     const { activeTab } = this.state;


// Mobile bottom bar (Figma "Bottom Bar"): the centre item is the chat button
const menuItems = [
      {
        key: "home",
        label: "Home",
        path: "/logged-in-user/dashboard",
        Icon: BottomBarHome,
      },
      {
        key: "appointment",
        label: "Appointment",
        path: "/logged-in-user/consultation-history",
        Icon: BottomBarAppointment,
      },
      {
        key: "chat",
        label: "Chat",
        isChat: true,
      },
      {
        key: "videos",
        label: "Videos",
        Icon: BottomBarVideos,
        comingSoon: true,
      },
      {
        key: "pricing",
        label: "Pricing",
        path: "/logged-in-user/subscription-plan",
        Icon: BottomBarPricing,
      },
    ];


const { pathname } = this.props?.location || {};

const shouldShowBottomBar =
  this.state.isBottomBarVisible &&
  pathname.startsWith("/logged-in-user");


  const hiddenRoutesChat = [
  "/logged-in-user/subscription-plan",
  "/logged-in-user/take-assessment",
  "/logged-in-user/begin-assessment",
  // "/logged-in-user/score-details",
  // "/logged-in-user/document-upload",
  "/logged-in-user/my-order",
  "/logged-in-user/memcheck",
  "/logged-in-user/health-profile",
];


    return (
      <Layout>
        <div className="top-color-shaded-content">
          {/* {this.props.location.pathname != "/logged-in-user/profile-lists" && ( */}
          {(!this.props.location.pathname.includes("guest-user") && !is_web_view) && <Affix offsetTop={1}>
            <Header className={"layout-header layout-header-label"}>
              <div className="header-detail">
                {PUBLIC_ROUTES.includes(this.props.location.pathname) ||
                  this.state.role == "Guest" ? (
                  <>
                    <img
                      src={this.state.organisation_mini_logo}
                    />
                    {GUEST_ROUTES.includes(this.props.location.pathname) && (
                      <Button
                        className="user-menu-button"
                        onClick={this.redirectToLogin.bind(this)}
                        style={{ margin: "0px 10px" }}
                      >
                        {CONSTANTS.LOGIN}
                      </Button>
                    )}
                  </>
                ) : (
                  <>
                    {/* <>
                        {this.props.location.pathname == "/role-types/select-role" && <img src={this.state.organisation_mini_logo} />}
                      </> */}
                    <label className="header-label">
                      <img
                        src={this.state.organisation_mini_logo}
                      />
                      {this.state.label_color_theme === "Burjeel Holdings" && (
                        <img
                          className="burjeel-header-logo"
                          src={require("assets/icons/burjeel-logo-export.svg").default}
                          alt="Burjeel"
                        />
                      )}
                      {this.state?.user_details?.role == "patient" || this.state.label_color_theme === "Burjeel Holdings" ? ""
                        // <Heading
                        // data={this.props} details={this.props.location.pathname == "/logged-in-user/my-account" ? this.props?.account_details : this.props?.user_details}/> 
                        : this.props.t(RouteFields[this.props.location.pathname.split("/")[2]], { lng: PRIMARY_LANG })}
                    </label>
                    <Space align="center">
                      {/* <div>Health Insurance</div> */}
                       {/* {(this.props?.user_details?.org_logo || this.props.location.pathname == "/logged-in-user/my-account") && this.props.location.pathname != "/role-types/select-role" && <div style={{ width: "115px", height: "auto" }}><img style={{ width: "100%", marginLeft: "0px", height: "auto" }} src={this.props.account_details.org_logo} /></div>} */}
                   
                   
                   {/* bell */}
                       {/* {this.state.selectedPath == "privacy-policy" || this.state.selectedPath == "profile-lists" || this.state.selectedPath == "select-language" ||        //account profile screen and account confirm screen does not show side
              this.state.selectedPath == "terms-of-use" || this.state.selectedPath == "pathway_process" || this.state.selectedPath == "standard-care" || this.state.selectedPath == "care-intro" ||
              (this.state.selectedPath == "login" && this.state?.role && this.state.role != "care-admin") || this.props.location.pathname == "/role-types/select-role" ||
              this.state.role == "Guest" || !this.props.isRoleSelected || (!this.props.user_details.is_profile_completed && this.props.user_details.org_type == "corporate")||(this.state.selectedPath =="privacy"||this.state.selectedPath =="terms") ? (
              <></>
            ) : (
                      <div className="hide_this_alert_moble" style={{ width: "45px", height: "auto" ,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
<img className="alert-icon" src={AlertIcon}>
                       
</img>
 </div>
  )} */}




                      {this.state?.user_details?.role === "patient" && this.props.location.pathname !== "/logged-in-user/profile-lists"  ? (
                        <div onClick={this.GotoProfile} style={{ cursor: "pointer" }}>
                          {this.props.location.pathname === "/logged-in-user/terms" ||
                          this.props.location.pathname === "/logged-in-user/privacy" ? (
                            <span onClick={(e) => {
                                e.stopPropagation();
                                this.props.history.goBack();
                              }}><TermsCloseIcon /></span>
                            // <CommonButton
                            //   label={
                            //     <Trans components={TS_STYLD_COMPS}>
                            //       {t(CONSTANTS.CLOSE, { lng: tgtLangST })}
                            //     </Trans>
                            //   }
                            //   onClick={(e) => {
                            //     e.stopPropagation();
                            //     this.props.history.goBack();
                            //   }}
                            //   disabled={false}
                            //   className="common-button-green"
                            // />
                          ) : this.props.location.pathname === "/logged-in-user/role-types/select-role" ||
                            this.props.location.pathname === "/role-types/select-role" ||
                            !this.state?.name ? (
                            <Avatar className="avatar-header" icon={<UserOutlined />} />
                          ) : this.props.location.pathname === "/logged-in-user/profile-lists" &&
                            this.props.account_details.profile_picture ? (
                            <SkeletonAvatar
                              className="avatar-profile-pic"
                              src={this.props.account_details.profile_picture}
                            />
                          ) : this.props.user_details.profile_picture &&
                            this.props.location.pathname !== "/logged-in-user/profile-lists" ? (
                            <SkeletonAvatar
                              className="avatar-profile-pic"
                              src={this.props.user_details.profile_picture}
                            />
                          ) : (
                            <Avatar className="avatar-header">
                              {utils.FormatName(
                                this.props.location.pathname === "/logged-in-user/profile-lists"
                                  ? this.props.account_details?.first_name
                                    ? this.props.account_details?.first_name[0]
                                    : ""
                                  : this.state?.name
                                  ? this.state?.name[0]
                                  : ""
                              )}
                            </Avatar>
                          )}
                        </div>
                      ) : (
                        <Dropdown
                          menu={{
                            items: logOutDropDown,
                            className: "logout-drop-down-header",
                          }}
                          placement="bottomLeft"
                          arrow
                        >
                          {(this.props.location.pathname == "/logged-in-user/role-types/select-role" ||
                            this.props.location.pathname == "/role-types/select-role" ||
                            !this.state?.name) ? (
                            <Avatar className="avatar-header" icon={<UserOutlined />} />
                          ) : this.props.location.pathname == "/logged-in-user/profile-lists" &&
                            this.props.account_details.profile_picture ? (
                            <SkeletonAvatar
                              className="avatar-profile-pic"
                              src={this.props.account_details.profile_picture}
                            />
                          ) : this.props.user_details.profile_picture &&
                            this.props.location.pathname != "/logged-in-user/profile-lists" ? (
                            <SkeletonAvatar
                              className="avatar-profile-pic"
                              src={this.props.user_details.profile_picture}
                            />
                          ) : (
                            <Avatar className="avatar-header">
                              {utils.FormatName(
                                this.props.location.pathname == "/logged-in-user/profile-lists"
                                  ? this.props.account_details?.first_name
                                    ? this.props.account_details?.first_name[0]
                                    : ""
                                  : this.state?.name
                                  ? this.state?.name[0]
                                  : ""
                              )}
                            </Avatar>
                          )}
                        </Dropdown>
                      )}




                      {/* <Dropdown
                        menu={{
                          items: logOutDropDown,
                          className: "logout-drop-down-header"
                        }}
                        placement="bottomLeft"
                        arrow
                      >
                        {(this.props.location.pathname == "/logged-in-user/role-types/select-role" || this.props.location.pathname == "/role-types/select-role" || !this.state?.name) ?
                          <Avatar className="avatar-header" icon={<UserOutlined />} /> : (this.props.location.pathname == "/logged-in-user/profile-lists" && this.props.account_details.profile_picture) ? <Avatar className="avatar-profile-pic" src={this.props.account_details.profile_picture} />
                            : (this.props.user_details.profile_picture && this.props.location.pathname != "/logged-in-user/profile-lists") ?
                              <Avatar className="avatar-profile-pic" src={this.props.user_details.profile_picture} />
                              :
                              <Avatar
                                className="avatar-header"
                              >
                                {utils.FormatName(this.props.location.pathname == "/logged-in-user/profile-lists" ? (this.props.account_details?.first_name ? this.props.account_details?.first_name[0] : "") : (this.state?.name ? this.state?.name[0] : ""))}
                              </Avatar>
                        }
                      </Dropdown>   */}


                      {/* {(this.props.location.pathname.includes("logged-in-user")) &&
                      <div onClick={this.GotoProfile}>
                          {(this.props.location.pathname == "/logged-in-user/role-types/select-role" || this.props.location.pathname == "/role-types/select-role" || !this.state?.name) ?
                          <Avatar className="avatar-header" icon={<UserOutlined />} /> : (this.props.location.pathname == "/logged-in-user/profile-lists" && this.props.account_details.profile_picture) ? <Avatar className="avatar-profile-pic" src={this.props.account_details.profile_picture} />
                            : (this.props.user_details.profile_picture && this.props.location.pathname != "/logged-in-user/profile-lists") ?
                              <Avatar className="avatar-profile-pic" src={this.props.user_details.profile_picture} />
                              :
                              <Avatar
                                className="avatar-header"
                              >
                                {utils.FormatName(this.props.location.pathname == "/logged-in-user/profile-lists" ? (this.props.account_details?.first_name ? this.props.account_details?.first_name[0] : "") : (this.state?.name ? this.state?.name[0] : ""))}
                              </Avatar>
                        }
                        </div>
                       } */}









                      {/* <Button
                    className="sidebar-toggle-button"
                    onClick={this.toggleSidebar}
                    icon={<MenuIcon  style={{fontSize: '30px' }} />}
                  
                    style={{ marginRight: "10px" }}
                  /> */}

                    </Space>
                  </>
                )}
              </div>
            </Header>
          </Affix>}
          {(HEADER_GUEST_ROUTES.includes(this.props?.location?.pathname) && !is_web_view) &&
            <Affix>
              <Header className={"layout-header layout-header-label"}>
                <div className="header-detail" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <img src={this.state.organisation_mini_logo} />

                  {/* Show Login + Signup only on specific guest paths */}
                  {/* {["/guest-user/begin-assessment", "/guest-user/take-assessment" , "/guest-user/assessment-completion"].includes(
                    this.props?.location?.pathname
                  ) && (
                      <div className="header_login_signup_btn">
                        <CommonButton
                          label={
                            <Trans components={TS_STYLD_COMPS}>
                              {t(CONSTANTS.LOGIN_CAPS, { lng: tgtLangST })}
                            </Trans>
                          }
                          // onClick={() => this.handleLogin()}
                          onClick={this.redirectToLogin.bind(this)}
                          disabled={false}
                          className="common-button-green login-btn-new-header"
                        />

                        <CommonButton
                          label={
                            <Trans components={TS_STYLD_COMPS}>
                              {t(CONSTANTS.SIGNUP_CAPS, { lng: tgtLangST })}
                            </Trans>
                          }
                          onClick={() => this.handleSignup()}
                          disabled={false}
                          className="common-button-green signup-btn-new-header"
                        />
                      </div>
                    )} */}
                </div>
              </Header>
            </Affix>
          }

          {/* )} */}
        </div>
        {/* <Layout className="side-menu-layout"> */}
        {this.state.showNetworkBar && (
          <div
            className={
              this.state.isOnline ? "back-online-alert" : "offline-alert"
            }
          >
            <span>{this.state.isOnline ? ONLINE_MSG : OFFLINE_MSG}</span>
          </div>
        )}
        <Layout
          className={`page-layout ${this.state.role == "Guest" && "signup-scrollbar-hidden"
            }`}
        >
     <div className={this.state.selectedPath == "privacy-policy" || this.state.selectedPath == "profile-lists" || this.state.selectedPath == "select-language" ||        //account profile screen and account confirm screen does not show side
            this.state.selectedPath == "terms-of-use" || this.state.selectedPath == "pathway_process" || this.state.selectedPath == "standard-care" || this.state.selectedPath == "care-intro" ||
            (this.state.selectedPath == "login" && this.state?.role && this.state.role != "care-admin") || this.props.location.pathname == "/role-types/select-role" ||
            this.state.role == "Guest" || !this.props.isRoleSelected || (!this.props.user_details.is_profile_completed && this.props.user_details.org_type == "corporate")||(this.state.selectedPath =="privacy"||this.state.selectedPath =="terms") ? "" : "sider-content-grid"}>

            { 
            // this.props.location.pathname.startsWith("/care-admin") ||
             this.state.selectedPath == "privacy-policy" || this.state.selectedPath == "profile-lists" || this.state.selectedPath == "select-language" ||        //account profile screen and account confirm screen does not show side
              this.state.selectedPath == "terms-of-use" || this.state.selectedPath == "pathway_process" || this.state.selectedPath == "standard-care" || this.state.selectedPath == "care-intro" ||
              (this.state.selectedPath == "login" && this.state?.role && this.state.role != "care-admin") || this.props.location.pathname == "/role-types/select-role" ||
              this.state.role == "Guest" || !this.props.isRoleSelected || (!this.props.user_details.is_profile_completed && this.props.user_details.org_type == "corporate")||(this.state.selectedPath =="privacy"||this.state.selectedPath =="terms") ? (
              <></>
            ) : (
              <Sider
                // className={this.props.user_details?.org_name && this.props.location.pathname != "/logged-in-user/profile-lists" && this.props.user_details.role == "patient" && "org-color"} 
                 className={
    `
      ${this.props.user_details?.org_name &&
      this.props.location.pathname != "/logged-in-user/profile-lists" &&
      this.props.user_details.role == "patient"
        ? "org-color"
        : ""
      }
      show-sider-${this.props.user_details.role}
    `
  }
                // collapsible={location.pathname.includes("/video-consultation")?false:true}
                // collapsed={location.pathname.includes("/video-consultation")?true:this.state.collapse}
                collapsible={false}
                collapsed={true}
                breakpoint={"lg"}
                theme="dark"
                onCollapse={(value) => {
                  this.setState({ collapse: value });
                  this.props.setCollapseValue(value);
                }}
                style={{
                  overflow: "auto",
                  height: "100vh",
                  position: "sticky",
                  top: 0,
                  left: 0,
                  background: "#fcfcfd",
                  borderRight: "2px solid #EAECF0",
                }}
              // className={`side-menu-layout-container ${this.getSidebarStatus()}`}
              >
                {/* <div
              // className={location.pathname.includes("/video-consultation")?"n-logo2":"n-logo"}
              className="n-logo2"
              style={{ position: "sticky", top: 0, zIndex: 1, background: "#fcfcfd", }}
            >
              <div
                style={{
                  height: 32,
                  display: "flex",
                  alignItems: "initial",
                }}
                className={this.state.collapse?"":"niyama-new-logo"}
              >
                <img
                  // src={
                  //   this.state.collapse || location.pathname.includes("/video-consultation")
                  //     ? this.state.organisation_mini_logo
                  //     : this.state.organisation_company_logo
                  // }
                  src={this.state.organisation_mini_logo}
                />
              </div>
            </div> */}
                <Menu
                  mode="inline"
                  inlineCollapsed
                  className="layout-menu"
                  // expandIcon={<div></div>}
                  // className="side-menu-layout"
                  // disabled={this.state.selectedPath == "coupon-apply"}
                  // selectedKeys={[this.state.selectedPath]}
                  openKeys={this.state.openKeys}
                  onOpenChange={this.onOpenChange.bind(this)}
                  selectedKeys={(this.props?.location?.state?.from != 'assessment-completion') ? [this.props.recent_path_route] : []}
                  onSelect={(e) => {
                    if (e.key == "logout") {
                      this.openLogout()
                    } else {
                      this.setState({
                        selectedPath: e.key,
                      });
                    }
                    this.props.removeFilteredValue("All")
                    this.props.removeFilteredCouponValue("")
                  }}
                  onClick={this.onOpenChange.bind(this)}
                  theme="dark"
                  items={this.prepareRoutes(this.state.routes)}
                ></Menu>
              </Sider>
            )}

            <div className={`${(this.props.location.pathname != "/logged-in-user/profile-lists" && this.props.location.pathname != "/role-types/select-role" && (HEADER_GUEST_ROUTES.includes(this.props?.location?.pathname) || !this.props.location.pathname.includes("guest-user"))) ? "layout-main-container" : "layout-main-container-without-header"} ${(this.state.role == "Guest" || this.props?.location?.pathname.includes("care-admin-domain")) ? "conditional-height" : ""} ${this.props?.location?.pathname == "/guest-user/getpersonalised" && "getPersonalised-scroll"}`} >
              <div className={`${this.state?.role === "patient" && (this.props?.location?.pathname === "/logged-in-user/score-details" || this.props?.location?.pathname === "/logged-in-user/begin-assessment") ? "layout-inner-without-header-main-container" : (this.props.location.pathname !== "/logged-in-user/profile-lists" ? (this.state.role === "patient" ? "layout-inner-with-header-main-container patient-padding" : "layout-inner-with-header-main-container") : "layout-inner-without-header-main-container")} ${(this.props.location.pathname.includes("guest-user")) && "padding-for-guest-user"}`}
              >
                {/* <div className={`${this.props.location.pathname != "/guest-user/login" ? "top-2nd-content" : "top-2nd-content-hide"}`}>
            <div>
              <SubHeaderLeft data={this.props}/>
            </div>
            <div >
              <SubHeaderCenter data={this.props}/>
            </div>
            <div >
              <SubHeaderRight data={this.props}/>
            </div>

          </div> */}
          {/* <div className="dash-alert-wrapper">
  <div className="dash-alert-slider" onScroll={this.handleAlertScroll}>
                {this.state.alertVisible && this.props.location.pathname === "/logged-in-user/dashboard" && this.isTimezoneDifferent() && (
                  <div className="dash-alert-item">
                  <Alert
                    className="hi-form-alert-dashboard alert-dash"
                    closable={false}
                    icon={<Time_Zone_Dash />} 
                    message={
                      <div className="alert-content-time">
                        <div>
                          <img className="icon-alert-dash" src={Time_Zone_Dash} alt="Time Zone" />
                        </div>
                        <div className="alert-content-time-text" style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                          <span className="alert-content-time-text1" style={{ fontWeight: 500 }}>
                            <Trans components={TS_STYLD_COMPS}>
                              {t(CONSTANTS.CURRENT_TIME_ZONE, { lng: tgtLangST })}
                            </Trans>
                            <span className="alert-content-timezone" style={{ marginLeft: '2px' }}>
                                ”{this.getCurrentUTCOffset()}”
                              </span>
                          </span>
                          <span className="alert-content-time-text2" onClick={this.GotoProfile} style={{ fontSize: '13px', opacity: 0.85 }}>
                            {t(CONSTANTS.SAVE_PROFILE_SETTING, { lng: tgtLang })}
                          </span>
                        </div>
                      </div>
                    }
                    action={
                      <div className="alert-content-time">
                        <Button
                           onClick={this.updateTimeZone}
                          className=" close-time-btn"
                          size="small"
                          type="primary"
                  
                        >
                          SAVE
                        </Button>
                        <div>
                          <img
                            onClick={() => {
                              this.setState({ alertVisible: false });
                            }}
                            style={{ cursor: "pointer" }}
                            src={X_close} alt="Time Zone" />
                        </div>
                      </div>

                    }

                  />
                  </div>
                )}
                 {this.state.alertVisibleLang && this.props.location.pathname === "/logged-in-user/dashboard" && this.isLanguageDifferent() && (
                  <div className="dash-alert-item">
                  <Alert
                    className="hi-form-alert-dashboard alert-dash"
                    closable={false}
                    icon={<Lang_Dash />} 
                    message={
                      <div className="alert-content-time">
                        <div>
                          <img className="icon-alert-dash" src={Lang_Dash} alt="Time Zone" />
                        </div>
                        <div className="alert-content-time-text" style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                          <span className="alert-content-time-text1" style={{ fontWeight: 500 }}>
                            <Trans components={TS_STYLD_COMPS}>
                              {t(CONSTANTS.CURRENT_LANG, { lng: tgtLangST })}
                            </Trans>
                            <span className="alert-content-timezone" style={{ marginLeft: '2px' }}>
                                ”{this.getCurrentLanguageName()}”
                              </span>
                          </span>
                          <span className="alert-content-time-text2" onClick={this.GotoProfile} style={{ fontSize: '13px', opacity: 0.85 }}>
                            {t(CONSTANTS.SAVE_PROFILE_SETTING, { lng: tgtLang })}
                          </span>
                        </div>
                      </div>
                    }
                    action={
                      <div className="alert-content-time">
                        <Button
                           onClick={this.updateLanguage}

                          className=" close-time-btn"
                          size="small"
                          type="primary"
                     
                        >
                          SAVE
                        </Button>
                        <div>
                          <img
                            onClick={() => {
                              this.setState({ alertVisibleLang: false });
                            }}
                            style={{ cursor: "pointer" }}
                            src={X_close} alt="Time Zone" />
                        </div>
                      </div>

                    }

                  />
                  </div>
                )}
             
                </div>
                {this.getVisibleAlertsCount() > 1 && (
    <div className="dash-alert-dots">
      {Array.from({ length: this.getVisibleAlertsCount() }).map((_, i) => (
        <span
          key={i}
          className={`dot ${
            this.state.activeAlertIndex === i ? "active" : ""
          }`}
        />
      ))}
    </div>
  )}

                </div> */}
                
                <Content
                  className={
                    this.state.baseUrl === "/guest-user" ||
                    this.props.location.pathname === "/role-types/select-role"
                      ? "login-content-container"
                      : this.props.location.pathname === "/logged-in-user/terms" ||
                        this.props.location.pathname === "/logged-in-user/privacy"
                      ? "main-content-container without-padding"
                      : "main-content-container"
                  }
                  id="dashboard-root-container"
                >
                  <Heading data={this.props} user_details={this.state?.user_details} account_details={this.state?.account_details}/>
                  <div id="toast-container" style={{ height: "unset" }}></div>

                  <React.Suspense fallback={<Loader tgtLangST={tgtLangST} />}>
                    <Switch>
                      {this._routesPath}
                      <Route
                        render={({ location }) => {
                          let { search } = location;
                          let queryParams = new URLSearchParams(search);
                          let queryParamString = queryParams.toString();
                          let redirectTo = {
                            pathname: `${baseUrl}/${(!this.props.isRoleSelected &&
                              this.state.role == "role")
                              ? "select-role" :
                              this.state.role == "care-admin"
                                ? "care-admin-domain"
                                : this.state.user_details?.is_profile_active == false &&
                                  !history?.state?.state?.loadDashboard
                                  ? "profile-lists"
                                  : "dashboard"
                              }`,
                            state: { fromPath: this.state.selectedPath },
                            search: queryParamString
                          }
                          return <Redirect from="/" to={redirectTo} />;
                        }}
                      />
                      <Route>
                        <PageNotFound />
                      </Route>
                    </Switch>
                  </React.Suspense>
                  {this.state.role == "patient" &&
                    this.state.selectedPath &&
                    this.state.selectedPath != "video-consultation" &&
                    this.state.selectedPath != "profile-lists" &&
                    this.state.selectedPath != "terms-of-use" &&
                    this.state.selectedPath != "privacy-policy" ? (
                    // <>
                    //   {(this.state.openPatientChat || this.props.isChatOpened) ? (
                    //     <PatientChatWidgetNewVersion
                    //       isLiveChatOpen={this.state.isLiveChatOpen}
                    //       isAiBotChatOpen={this.state.isAiBotChatOpen}
                    //       chatDetails={this.state.chatDetails}
                    //       clearAiBotChatDtls={this.clearAiBotChatDetails.bind(this)}
                    //       clearChatDetails={this.clearChatDetails.bind(this)}
                    //       closeChatWindow={(e) => {
                    //         this.setState({ openPatientChat: false });
                    //         if (this.props.isChatOpened) {
                    //           this.props.setIsChatOpened(false);
                    //         }
                    //       }}
                    //       includePrimeLang={this.props.includePrimeLang}
                    //       ai_support={this.state.ai_support}
                    //     />
                    //     // <PatientChatWidget
                    //     //   openChat={this.state.openPatientChat}
                    //     //   isLiveChatOpen={this.state.isLiveChatOpen}
                    //     //   chatDetails={this.state.chatDetails}
                    //     //   clearChatDetails={this.clearChatDetails.bind(this)}

                    //     //   closeChat={(e) => {
                    //     //     this.props.retain_chat_data.length==0?
                    //     //     this.setState({
                    //     //       openPatientChat: false,
                    //     //     }):this.setState({ai_support:true})
                    //     //   }}
                    //     // ai_support={this.state.ai_support}
                    //     // />
                    //   ) : (
                    //     (!this.props.user_details.is_profile_completed && this.props.user_details.org_type == "corporate") ? "" :
                    //       <FloatButton
                    //         // shape="rectangle"
                    //         type="primary"
                    //         className="float-button-icon"
                    //         style={{
                    //           // right: 4, 
                    //           padding: "28px"
                    //         }}
                    //         icon={<img style={{ width: "72px" }} className="chat-icon" src={icons.chat_img} />}
                    //         onClick={(e) => {
                    //           this.setState({
                    //             openPatientChat: true,
                    //           });
                    //           this.props.setIsChatOpened(true);
                    //         }}
                    //       />
                    //   )}
                    // </>
                    <>
  {(this.state.openPatientChat || this.props.isChatOpened) ? (
    <PatientChatWidgetNewVersion
      isLiveChatOpen={this.state.isLiveChatOpen}
      isAiBotChatOpen={this.state.isAiBotChatOpen}
      chatDetails={this.state.chatDetails}
      clearAiBotChatDtls={this.clearAiBotChatDetails.bind(this)}
      clearChatDetails={this.clearChatDetails.bind(this)}
      closeChatWindow={(e) => {
        this.setState({ openPatientChat: false });
        if (this.props.isChatOpened) {
          this.props.setIsChatOpened(false);
        }
      }}
      includePrimeLang={this.props.includePrimeLang}
      ai_support={this.state.ai_support}
    />
  ) : (
    (!this.props.user_details.is_profile_completed &&
      this.props.user_details.org_type === "corporate")
      ? ""
      : (
          !(
  window.innerWidth <= 768 &&
  hiddenRoutesChat.includes(this.props?.location?.pathname)
) && (
            <FloatButton
              type="primary"
              className="float-button-icon"
              style={{ padding: "28px" }}
              icon={
                <img
                  style={{ width: "72px" }}
                  className="chat-icon"
                  src={icons.chat_img}
                />
              }
              onClick={(e) => {
                this.setState({ openPatientChat: true });
                this.props.setIsChatOpened(true);
              }}
            />
          )
        )
  )}
</>

                  ) : null}
                </Content>
                {(this.state.role == "Guest" || this.state.role == "patient" || this.props?.location?.pathname.includes("care-admin-domain") || this.props.location.pathname == "/role-types/select-role") ? (
                  (this.state?.role === "patient" && this.props?.location?.pathname === "/logged-in-user/score-details" || this.props?.location?.pathname === "/logged-in-user/begin-assessment") ? (
                    <Footer className="foot-container">
                      {this.props?.location?.pathname === "/logged-in-user/score-details" ? (
                        <div className="assess-score-btm-txt">
                          <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.BOTTOM_INFO_1, { lng: tgtLangST })}</Trans>
                        </div>
                      ) : (<>
                        {/* <div className="take-assessment-txt" >
                          <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.EVERY_15_DAYS_TAKE_ASSESSMENT, { lng: tgtLangST })}</Trans>
                        </div> */}
                        </>
                      )}
                    </Footer>
                  ) :
                    <></>
                ) : this.state.label_color_theme === "Burjeel Holdings" ? (
                  <></>
                ) : (
                  <Footer className={this.state?.role == "care-admin" && "care-admin-footer"} style={{ textAlign: "center", minHeight: "45px", padding: "8px 0px", position: "absolute", bottom: "0", right: "0", width: "calc(100% - 0px)", display: "grid", justifyContent: "center", alignItems: "end" }}>
                    {/* <FloatButton.BackTop /> */}
                    <div className="footer-font-family" style={{ fontSize: "12px" }}>
                      {this.state?.role != "care-admin" && <div style={{ paddingBottom: "4px" }}>{CONSTANTS.IN_CASE_OF} {this.state.careadmin_contact_theme}</div>}
                      <div><CopyrightOutlined /><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.COPYRIGHT_2025_ZILOY, { lng: tgtLangST })}</Trans></div>
                    </div>
                  </Footer>
                )}
              </div>
            </div>
          </div>

          {this.state.role == "care-admin" && this.state.selectedPatient ? (
            <div className="chat-main-wrapper care-admin">
              {this.state.selectedPatient.map((selectedPatient) => {
                return (
                  <CareChatWidget
                    selectedPatient={selectedPatient}
                    closeChat={(selected) => {
                      let selecteChatList = (
                        this.state.selectedPatient || []
                      ).filter(
                        (m) => m.patient_identity != selected.patient_identity
                      );
                      this.setState({
                        selectedPatient: selecteChatList,
                      });
                    }}
                  />
                );
              })}
            </div>
          ) : null}

          {/* {this.state.role == "patient" && this.state.selectedPath && this.state.selectedPath != "video-consultation" && this.state.selectedPath != 'profile-lists' && this.state.selectedPath != 'terms-of-use' && this.state.selectedPath != 'privacy-policy' ? <div >
              {
                this.state.openPatientChat ? <PatientChatWidget
                  openChat={this.state.openPatientChat}
                  closeChat={e => {
                    this.setState({
                      openPatientChat: false
                    })
                  }} />
                  : <img className="chat-icon" src={icons.icon_chat} onClick={e => {
                    this.setState({
                      openPatientChat: true
                    })
                  }} />
              }
            </div> : null} */}
          {/* {this.state.role == "Guest" ? (
            <></>
          ) : (
            <Footer style={{ textAlign: "center", padding: "8px 0px" }}>
              <FloatButton.BackTop />
              <div style={{ fontSize: "12px"}}><div style={{paddingBottom:"4px"}}>In case of emergency, please contact Care Admin: +971 80023</div>
              <div><CopyrightOutlined />2023 Ziloy Healthcare.inc</div>
              </div>
            </Footer>
          )} */}

          {/* <Footer selectedPath={this.state.selectedPath} /> */}
        </Layout>
        {/* <Drawer open={this.state.isUTMModalOpen} placement="bottom" closable={false} height='240'>
          <div className="browser-app-open-modal">
            <div className="open-with">{CONSTANTS.OPEN_WITH}</div>
            <div className="niyama-app-open" onClick={this.storeRedirect.bind(this, true)}>
              <div className="niyama-app">
                <img src={icons.niyama_app_icon_modal} />
                <span>{CONSTANTS.NIYAMA_APP}</span>
              </div>
              <div className="app-open">
                <span>{CONSTANTS.OPEN}</span>
                <img src={icons.arrow_right_modal} />
              </div>
            </div>
            <div className="niyama-app-open" onClick={this.storeRedirect.bind(this, false)}>
              <div className="niyama-app">
                <img src={icons.browser_app_icon_modal} />
                <span>{CONSTANTS.WEB_BROWESER}</span>
              </div>
              <div className="app-open">
                <span>{CONSTANTS.CONTINUE}</span>
                <img src={icons.arrow_right_modal} />
              </div>
            </div>
          </div>
        </Drawer> */}

        <Drawer
  title={null}
  placement="left"
  closable={true}
  onClose={this.toggleSidebar}
  open={this.state.isSidebarOpen}
  key="sidebar-drawer"
  width={250}
  style={{ padding: 0 }}
  bodyStyle={{ padding: 0 }}
>
  <div
    style={{
      height: "100vh",
      background: "#fcfcfd",
      borderRight: "2px solid #EAECF0",
    }}
  >
    <Menu
      mode="inline"
      className="layout-menu"
      openKeys={this.state.openKeys}
      onOpenChange={this.onOpenChange.bind(this)}
      selectedKeys={(this.props?.location?.state?.from != 'assessment-completion') ? [this.props.recent_path_route] : []}
      onSelect={(e) => {
        if (e.key == "logout") {
          this.toggleSidebar();
          this.openLogout();
        } else {
          this.setState({
            selectedPath: e.key,
          });
          this.toggleSidebar(); // Close the drawer after selecting a menu item
        }
        this.props.removeFilteredValue("All");
        this.props.removeFilteredCouponValue("");
      }}
      onClick={this.onOpenChange.bind(this)}
      theme="dark"
      items={this.preparesmallRoutes(this.state.routes)}
    />
  </div>
</Drawer>


 {/* {this.state.isBottomBarVisible && (
      <div className="bottom-bar">
  <div className="bottom-bar-content">
    <div style={{width:"29px", height:"42px"}}>
      <img src={icons.Bottom_home} alt="home" />
      <h1>Home</h1>
    </div>
       <div style={{width:"62px", height:"42px"}}>
      <img src={icons.Bottom_assessment} alt="assessment" />
      <h1>Assessment</h1>
    </div>
      <div style={{width:"59px", height:"42px"}}>
      <img src={icons.Bottom_appointment} alt="appointment" />
      <h1>Appointment</h1>
    </div>
      <div style={{width:"40px", height:"42px"}}>
      <img src={icons.Bottom_upload} alt="upload" />
      <h1>Upload</h1>
    </div>
       <div style={{width:"39px", height:"42px"}}>
      <img src={icons.Bottom_profile} alt="profile" />
      <h1>Profile</h1>
    </div>
  </div>
</div>

      )} */}


      {!(
  this.state.selectedPath === "privacy-policy" ||
  this.state.selectedPath === "profile-lists" ||
  this.state.selectedPath === "select-language" ||
  this.state.selectedPath === "terms-of-use" ||
  this.state.selectedPath === "pathway_process" ||
  this.state.selectedPath === "standard-care" ||
  this.state.selectedPath === "care-intro" ||
  this.state.selectedPath === "privacy" ||
  this.state.selectedPath === "terms" ||
  this.state.selectedPath === "memcheck" ||
  (this.state.selectedPath === "login" &&
    this.state?.role &&
    this.state.role !== "care-admin") ||
  this.props.location.pathname === "/role-types/select-role" ||
  this.state.role === "Guest" ||
  !this.props.isRoleSelected ||
  (!this.props.user_details.is_profile_completed &&
    this.props.user_details.org_type === "corporate")
) && shouldShowBottomBar && (
  <div className="bottom-bar">
    <div className="bottom-bar-content">
      {menuItems.map((item) => item.isChat ? (
        <button
          key={item.key}
          type="button"
          className="bottom-item bottom-item-chat"
          aria-label={item.label}
          onClick={this.openChatFromBottomBar}
        >
          <img src={icons.bottom_bar_chat} alt="" />
        </button>
      ) : (
        <div
          key={item.key}
          className={`bottom-item ${
            activeTab === item.key ? "active" : ""
          }`}
          onClick={() => this.handleBottomBarItem(item)}
        >
          <item.Icon className="bottom-item-icon" aria-hidden="true" />
          <h1>{item.label}</h1>
        </div>
      ))}
    </div>
  </div>
)}

      </Layout>
    );
  } 
}

const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer.user_details,
    account_details: state.loginReducer.account_details,
    isRoleSelected: state.loginReducer.isRoleSelected,
    isMultipleRolePresent: state.loginReducer.isMultipleRolePresent,
    up_coming_path: state.loginReducer.upComingPath,
    recent_path_route: state.loginReducer.recentRoutes,
    selected_care_admin_domain: state.careAdminReducer.careAdminDomain,
    previousPath: state.breadCrumbReducer.previousPath,
    networkError: state.loginReducer.networkError,
    collapseMenu: state.dashboardReducer.collapseMenu,
    label_color_theme: state.dashboardReducer.label_color_theme,
    careadmin_contact_theme: state.dashboardReducer.careadmin_contact_theme,
    retain_chat_data: state.aiChatReducer.chatData,
    retainedAiBotChatDetails: state.aiChatReducer.aiBotChatDetails,
    isChatOpened: state.loginReducer.isChatOpened,
    includePrimeLang: state.loginReducer.includePrimeLang
  };
};

const mapDispatchToProps = (dispatch) => {

  return {
    // Crumbroutes:(e) => dispatch(breadCrumbroutes(e)),
    routesDelete: (e) => dispatch(breadCrumbroutesDelete(e)),
    logout: () => dispatch({ type: "USER_LOGOUT" }),
    recentRoute: (e) => dispatch(recentRoutes(e)),
    setNetworkDrop: (e) => dispatch(setNetworkDrop(e)),
    setLanguage: (e) => dispatch(setLanguage(e)),

    upComingPath: (e) => dispatch(upComingPath(e)),
    setCollapseValue: (e) => dispatch(setCollapse(e)),
    setLabelValue: (e) => dispatch(setLabelColorTheme(e)),
    setContactValue: (e) => dispatch(setContactColorTheme(e)),
    removeFilteredValue: (e) => dispatch(removeFilteredValue(e)),
    resetFunnelingData: (e) => dispatch(resetFunnelingData()),
    removeCouponValue: (e) => dispatch(removeCouponValue(e)),
    removeFilteredCouponValue: (e) => dispatch(removeFilteredCouponValue(e)),
    setIsChatOpened: (e) => dispatch(setIsChatOpened(e)),
    setTimeZoneOffset: (e) => dispatch(setTimeZoneOffset(e)),

  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MainLayout))
);
